import React from "react";

function Profile() {
	return (
		<div>
			<div className="container">
				<div className="container--inner">
					<h1>Profile</h1>
				</div>
			</div>
		</div>
	);
}

export default Profile;
